import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ProfileService, NotificationService } from '@core';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.less'],
    standalone: false
})
export class ChangePasswordComponent implements OnInit {
  changePasswordForm!: FormGroup;
  loading: boolean = false;


  constructor(
    private fb: FormBuilder,
    private profileService: ProfileService,
    private notify: NotificationService,
  ) { }

  ngOnInit(): void {
    this.buildChangePasswordForm()
  }

  buildChangePasswordForm() {
    this.changePasswordForm = this.fb.group({
      old_password: [null, Validators.compose([Validators.required])],
      password: [
        null,
        Validators.compose([Validators.required, Validators.minLength(8)]),
      ],
      password_confirmation: [
        null,
        [
          Validators.required,
          Validators.minLength(8),
          this.confirmationValidator,
        ],
      ],
    });

  }

  confirmationValidator = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { required: true };
    } else if (
      control.value !== this.changePasswordForm.controls.password.value
    ) {
      return { confirm: true, error: true };
    }
    return {};
  };

  submitChangedPassword() {
    this.loading = true;
    if (!this.changePasswordForm.valid) {
      this.changePasswordForm.controls.current_password.markAsDirty();
      this.changePasswordForm.controls.new_password.markAsDirty();
      this.changePasswordForm.controls.confirm_password.markAsDirty();
      return;
    }

    this.profileService
      .changeUserPassword(this.changePasswordForm.value)
      .then((res: any) => {
        this.loading = false;
        this.notify.success("", res?.message);
        this.changePasswordForm.reset();
      })
      .catch((err: any) => {
        this.loading = false;
        console.warn("", err?.message);
      });
  }

}
